import React from "react";
import { FaHtml5, FaCss3Alt, FaReact } from "react-icons/fa";
import { SiTailwindcss } from "react-icons/si";
import AOS from 'aos';
import 'aos/dist/aos.css'; 
import { useEffect } from "react";


function CodingLogo() {
  useEffect(() => {
    AOS.init({
      once: true,
    });
  }, []);
  return (
    <section className=" mt-28  border-y-2 pb-6 pt-6 md:pb-10 md:pt-10" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="400" data-aos-offset="100"
    data-aos-anchor-placement="top-bottom">
      <div className="container">
      <div className="w-full">
          <div className="flex justify-between">
            <div className="w-1/4">
              <FaHtml5 size={40} className="mx-auto text-[#E34F26] " />
            </div>
            <div className="w-1/4">
              <FaCss3Alt size={40} className="mx-auto text-[#2965F1] " />
            </div>
            <div className="w-1/4">
              <FaReact size={40} className="mx-auto text-blue-600" />
            </div>
            <div className="w-1/4">
              <SiTailwindcss size={40} className="mx-auto text-blue-500" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CodingLogo;
